"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabularConfiguration = void 0;
const ColumnTreeController_1 = require("../../components/ColumnTreeController");
const trans_1 = require("@common/tsutils/trans");
class TabularConfiguration {
    constructor() {
        this._recommendations = [];
        this._needs = [];
        this._metrics = [];
        this._categories = [];
        this._phch = [];
        this.filters = [];
        this.columnManager = new ColumnTreeController_1.ColumnManager([]);
        this.generalSearch = '';
        this.preSets = ['default'];
        this.unit = 'ha';
        this.mode = 'score';
        this.initializeTree();
        this.recommendations = [];
        this.needs = [];
        this.metrics = [];
        this.categories = [];
        this.phch = [];
        this.categoryHasMetric = (categoryName, metricName) => false;
    }
    set recommendations(val) {
        this._recommendations = val;
        this.initializeTree();
    }
    get recommendations() {
        return this._recommendations;
    }
    set categories(val) {
        this._categories = val;
        this.initializeTree();
    }
    set categoryHasMetric(val) {
        this._categoryHasMetric = val;
    }
    set needs(val) {
        this._needs = val;
        this.initializeTree();
    }
    set phch(val) {
        this._phch = val;
        this.initializeTree();
    }
    get needs() {
        return this._needs;
    }
    get phch() {
        return this._phch;
    }
    set metrics(val) {
        this._metrics = val;
        this.initializeTree();
    }
    get metrics() {
        return this._metrics;
    }
    initializeTree() {
        this.columnManager = new ColumnTreeController_1.ColumnManager([]); // limpia árbol anterior
        const recommendationChildren = this._recommendations.map((label, index) => ({
            key: `rec_sub${index + 1}`,
            label,
            checked: false
        }));
        const needsChildren = this._needs.map((label, index) => ({
            key: `need_sub${index + 1}`,
            label,
            checked: false
        }));
        const phchChildren = this._phch.map((label, index) => ({
            key: `phch_sub${index + 1}`,
            label,
            checked: false
        }));
        const categoriesChildren = this._categories.map((label, index) => ({
            key: `categorie_sub${index + 1}`,
            label,
            checked: false,
            children: this._metrics
                .filter(lbl => this._categoryHasMetric(label, lbl))
                .map((lbl, id) => ({
                key: `metric_cat${index}_sub${id + 1}`,
                label: lbl,
                checked: false
            }))
        }));
        this.columnManager.addRootTree(Object.assign({ key: 'recommendations', label: (0, trans_1.trans)('tabular.configuration.presets.recommendations') }, (recommendationChildren.length && { children: recommendationChildren })));
        this.columnManager.addRootTree(Object.assign({ key: 'needs', label: (0, trans_1.trans)('tabular.configuration.presets.needs') }, (needsChildren.length && { children: needsChildren })));
        this.columnManager.addRootTree(Object.assign({ key: 'phch_metrics', label: (0, trans_1.trans)('tabular.configuration.presets.phch_metrics') }, (phchChildren.length && { children: phchChildren })));
        this.columnManager.addRootTree(Object.assign({ key: 'metrics', label: (0, trans_1.trans)('tabular.configuration.presets.metrics') }, (categoriesChildren.length && { children: categoriesChildren })));
    }
    addFilter(f) {
        this.filters.push(f);
    }
    removeFilter(f) {
        this.filters = this.filters.filter((filter) => f.id !== filter.id);
    }
    setPreset(p) {
        this.preSets = [];
        this.preSets.push(p);
    }
    unsetPreset(p) {
        this.preSets = this.preSets.filter((preset) => preset !== p);
    }
    togglePreset(p) {
        // PONER ESTO CUANDO ESTEN BIEN LAS COLUMNAS
        /*         if(this.preSets.find((preset:PresetType) => preset === p)) {
                    this.preSets = this.preSets.filter((preset:PresetType) => preset !== p)
                } else {
                    this.preSets.push(p)
                } */
        this.columnManager.toggleAll(false);
        if (this.isPresetActive(p)) {
            this.preSets = [];
        }
        else {
            this.preSets = [];
            this.preSets.push(p);
            this.columnManager.toggle(p, true);
        }
    }
    isPresetActive(p) {
        return (this.preSets.find((preset) => preset === p)) ? true : false;
    }
    setMode(m) {
        let mode = m;
        this.mode = mode;
    }
    setUnit(u) {
        let unit = u;
        this.unit = unit;
    }
}
exports.TabularConfiguration = TabularConfiguration;
